import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";

import { TAAConstants } from "../../../../views/constants/taa-constants";
import { AccommsService } from "../../../../views/services/accomms.service";
import { CommonService } from "../../../../views/services/common.service";
import { PaperStepperComponent } from "../process-paper-request/stepper/paper-stepper.component";
import { AccSupportPlanService } from "../service/accsupportplan.service";
import { User } from "../../../../views/services/user.model";
import { AppService } from "../../../../views/services/app.service";

@Component({
  selector: "app-accsupportplan",
  templateUrl: "./accsupportplan.component.html",
  styleUrls: ["./accsupportplan.component.css"]
})
export class AccSupportPlanComponent implements OnInit, OnDestroy {
  public personName: string;
  public taaPin: string;
  public planTypeDiv: boolean = false;
  public savedPlanId: string = "";
  public savedPlanDuration: string = "";
  public savedAccomsPesronId: string;
  public savedEllPesronId: string;
  public savedEllPlan: string = "";
  public fourmoDiv: boolean = false;
  public oneyearDiv: boolean = false;
  public planDuration: string;
  public planOptions: Array<any> = [];
  public data: any;
  public ellValue: any;
  public planId: any;
  public ellPlainId: any;
  public selectedPlanDuration: any;
  public planYear: string;
  public accommodationPlan: boolean = false;
  public exceptionFlag: boolean = false;
  public ellSupportDiv: boolean = false;
  public errorMsg: boolean = false;
  public ellSupport: boolean = false;
  public ellPlanFlag: boolean = false;
  public planDurationFlag: boolean = false;
  public planFourMonthFlag: boolean = false;
  public planOneYearFlag: boolean = false;
  public showaccommodationPlan: boolean = false;
  public showPlanTypeDiv: boolean = false;
  public showEllDiv: boolean = false;
  public savedReq: any;
  public loading: boolean = true;
  public successMessage: boolean;
  public errorMessage: boolean;
  public enableSaveContinue: boolean = false;
  public userProfile: User;
  private subscriptions: Array<Subscription> = [];
  public isLoading: boolean = false;
  public personPlanIds: Array<any> = [];
  public statusCd: string;

  recordCount = "0";

  constructor(
    public stepper: PaperStepperComponent,
    private appService: AppService,
    public planService: AccSupportPlanService,
    public commonService: CommonService,
    public taaConstants: TAAConstants,
    private accommsService: AccommsService
  ) { }
  ngOnInit() {
    sessionStorage.setItem("reasonSubmitted", "");
    this.isLoading = true;
    if (sessionStorage.getItem("currentStudent")) {
      const studentDetails: any = JSON.parse(
        sessionStorage.getItem("currentStudent")
      );
      this.savedReq = studentDetails;
    }
    this.taaPin = this.savedReq ? this.savedReq.taaPin : "";
    this.personName = this.savedReq ? this.savedReq.personName : "";
    if (this.savedReq) {
      Observable.forkJoin(
        this.commonService.getFinishedRecordCount(this.savedReq.personId),
        this.planService.getPersonPlanById(this.savedReq.personId)
      )
        .finally(() => {
          this.isLoading = false;
        })
        .subscribe(([finishedRecordCount, response]) => {
          this.recordCount = finishedRecordCount as any;
          if (response) {
            const personPlan: any = response.body;
            this.enableSaveContinue = true;
            Observable.forkJoin(this.planService.getActivePlans()).subscribe(
              resp => {
                if (resp) {
                  this.data = resp[0].body;
                  for (let i = 0; i < this.data.length; i++) {
                    if (this.data[i].PLAN_NM !== "ELLPLAN") {
                      this.planOptions.push(this.data[i]);
                    } else if (this.data[i].PLAN_NM === "ELLPLAN") {
                      this.ellPlainId = this.data[i].PLAN_ID;
                    }
                  }
                  for (let i = 0; i < personPlan.length; i++) {
                    this.personPlanIds.push(personPlan[i].PLAN_ID);
                    if (
                      personPlan[i].RECV_ELL_SUPP_IN_SCH === null &&
                      personPlan[i].YEARS_ON_PLAN_NO === "<4"
                    ) {
                      this.savedAccomsPesronId = personPlan[i].PERSON_PLAN_ID;
                      this.planDuration = "4 Months";
                      this.savedPlanId = personPlan[i].PLAN_ID;
                      this.planFourMonthFlag = true;
                      this.fourmoDiv = true;
                      this.savedPlanDuration = "Less Than 4 Months";
                    } else if (
                      personPlan[i].RECV_ELL_SUPP_IN_SCH === null &&
                      personPlan[i].YEARS_ON_PLAN_NO === "=>4"
                    ) {
                      this.savedAccomsPesronId = personPlan[i].PERSON_PLAN_ID;
                      this.planDuration = "4 Months";
                      this.savedPlanId = personPlan[i].PLAN_ID;
                      this.planFourMonthFlag = true;
                      this.fourmoDiv = true;
                      this.savedPlanDuration = "4 Months or More";
                    } else if (
                      personPlan[i].RECV_ELL_SUPP_IN_SCH === null &&
                      personPlan[i].YEARS_ON_PLAN_NO === "<1"
                    ) {
                      this.savedAccomsPesronId = personPlan[i].PERSON_PLAN_ID;
                      this.planDuration = "Twelve Calendar Months";
                      this.savedPlanId = personPlan[i].PLAN_ID;
                      this.planOneYearFlag = true;
                      this.oneyearDiv = true;
                      this.savedPlanDuration = "Less Than Twelve Calendar Months";
                    } else if (
                      personPlan[i].RECV_ELL_SUPP_IN_SCH === null &&
                      personPlan[i].YEARS_ON_PLAN_NO === "=>1"
                    ) {
                      this.savedAccomsPesronId = personPlan[i].PERSON_PLAN_ID;
                      this.planDuration = "Twelve Calendar Months";
                      this.savedPlanId = personPlan[i].PLAN_ID;
                      this.planOneYearFlag = true;
                      this.oneyearDiv = true;
                      this.savedPlanDuration = "Twelve Calendar Months or More";
                    } else if (
                      personPlan[i].RECV_ELL_SUPP_IN_SCH === "Y" &&
                      personPlan[i].YEARS_ON_PLAN_NO === "NA"
                    ) {
                      this.savedEllPesronId = personPlan[i].PERSON_PLAN_ID;
                      this.savedEllPlan = "Yes";
                      this.ellPlanFlag = true;
                    } else if (
                      personPlan[i].RECV_ELL_SUPP_IN_SCH === "N" &&
                      personPlan[i].YEARS_ON_PLAN_NO === "NA"
                    ) {
                      this.savedEllPesronId = personPlan[i].PERSON_PLAN_ID;
                      this.savedEllPlan = "No";
                      this.ellPlanFlag = true;
                    } else if (
                      personPlan[i].RECV_ELL_SUPP_IN_SCH === null &&
                      personPlan[i].YEARS_ON_PLAN_NO === "NONE"
                    ) {
                      this.savedAccomsPesronId = personPlan[i].PERSON_PLAN_ID;
                      this.planTypeDiv = false;
                      this.exceptionFlag = true;
                      this.savedPlanId = personPlan[i].PLAN_ID;
                    }
                  }
                  Observable.forkJoin(
                    this.planService.getRequest(this.savedReq)
                  ).subscribe(res => {
                    if (res) {
                      const result: any = res[0].body;
                      if (result[0].REQ_TYP_ACCOM_FL === "Y") {
                        this.accommodationPlan = true;
                        this.planTypeDiv = true;
                      } else {
                        for (let j = 0; j < this.personPlanIds.length; j++) {
                          if (this.personPlanIds[j] !== this.ellPlainId) {
                            const data = {
                              PERSON_ID: this.savedReq.personId,
                              PLAN_ID: this.personPlanIds[j]
                            };
                            Observable.forkJoin(
                              this.planService.deletePlan(data)
                            )
                              .finally(() => { })
                              .subscribe(deletePlan => { });
                          }
                        }
                      }
                      if (result[0].REQ_TYP_ELL_SUPP_FL === "Y") {
                        this.isLoading = false;
                        this.ellSupportDiv = true;
                      } else if (result[0].REQ_TYP_ELL_SUPP_FL === "N") {
                        for (let j = 0; j < this.personPlanIds.length; j++) {
                          if (this.personPlanIds[j] === this.ellPlainId) {
                            const data = {
                              PERSON_ID: this.savedReq.personId,
                              PLAN_ID: this.personPlanIds[j]
                            };
                            Observable.forkJoin(
                              this.planService.deletePlan(data)
                            )
                              .finally(() => { })
                              .subscribe(deletePlan => { });
                          }
                        }
                      }
                    }
                  });
                }
              }
            );
          }
        });
    }

    this.appService.getUserProfile().then(user => this.userProfile = user);
  }
  ngOnDestroy() {
    for (const o of this.subscriptions) {
      o.unsubscribe();
    }
  }

  savePlanData = navigate => {
    if (!this.savedPlanId && this.accommodationPlan) {
      this.errorMsg = true;
      this.showaccommodationPlan = true;
    } else if (
      !this.savedPlanDuration &&
      !this.exceptionFlag &&
      this.planTypeDiv
    ) {
      this.errorMsg = true;
      this.showPlanTypeDiv = true;
    } else if (this.ellSupportDiv && !this.savedEllPlan) {
      this.errorMsg = true;
      this.showEllDiv = true;
    } else {
      this.isLoading = true;
      this.submitResult()
        .finally(() => {
          this.isLoading = false;
        })
        .subscribe(response => {
          if (navigate) {
            sessionStorage.setItem("planSubmitted", "true");
            this.stepper.goToNextStep();
          }
        });
    }
  }
  getStatusCode() {
    this.accommsService
      .getInternalRequests(this.savedReq.requestId)
      .subscribe(data => {
        this.accommsService
          .getRequestedStatusCode((data as any).REQUEST_STATUS_CODE_ID)
          .subscribe(success => {
            this.statusCd = (success as any).STATUS_CD;
          });
      });
  }
  public submitResult() {
    const obj = {
      PERSON_ID: this.savedReq.personId,
      CREATED_BY_DS: this.userProfile.loggedInUser,
      UPDATED_BY_DS: this.userProfile.loggedInUser,
      LOCKED_FL: 0
    };
    const updateRequest = {
      PERSON_ID: this.savedReq.personId,
      UPDATED_BY_DS: this.userProfile.loggedInUser,
      REQUEST_ID: this.savedReq.requestId,
      REQUEST_STATE_TX: "4"
    };
    if (
      (this.accommodationPlan && this.ellSupportDiv) ||
      this.accommodationPlan ||
      this.ellSupportDiv
    ) {
      const personAccomPlan = JSON.parse(JSON.stringify(obj));
      personAccomPlan["PLAN_ID"] = this.planId;
      personAccomPlan["YEARS_ON_PLAN_NO"] = this.selectedPlanDuration;
      personAccomPlan["RECV_ELL_SUPP_IN_SCH"] = "";

      const personEllPlan = JSON.parse(JSON.stringify(obj));
      personEllPlan["PLAN_ID"] = this.ellPlainId;
      personEllPlan["YEARS_ON_PLAN_NO"] = "NA";
      personEllPlan["RECV_ELL_SUPP_IN_SCH"] = this.ellValue;

      const updatePersonAccomPlan = {
        PERSON_PLAN_ID: this.savedAccomsPesronId,
        PERSON_ID: this.savedReq.personId,
        PLAN_ID: this.planId,
        UPDATED_BY_DS: this.userProfile.loggedInUser,
        YEARS_ON_PLAN_NO: this.selectedPlanDuration,
        RECV_ELL_SUPP_IN_SCH: ""
      };
      const updatePersonEllPlan = {
        PERSON_PLAN_ID: this.savedEllPesronId,
        PERSON_ID: this.savedReq.personId,
        PLAN_ID: this.ellPlainId,
        UPDATED_BY_DS: this.userProfile.loggedInUser,
        YEARS_ON_PLAN_NO: "NA",
        RECV_ELL_SUPP_IN_SCH: this.ellValue
      };
      if (this.accommodationPlan && this.ellSupportDiv) {
        if (this.savedAccomsPesronId && this.savedEllPesronId) {
          return Observable.forkJoin(
            this.planService.updatePersonPlan(updatePersonAccomPlan),
            this.planService.updatePersonPlan(updatePersonEllPlan),
            this.planService.updateRequest(updateRequest)
          );
        } else if (this.savedAccomsPesronId && !this.savedEllPesronId) {
          return Observable.forkJoin(
            this.planService.updatePersonPlan(updatePersonAccomPlan),
            this.planService.postPersonPlan(personEllPlan),
            this.planService.updateRequest(updateRequest)
          );
        } else if (!this.savedAccomsPesronId && this.savedEllPesronId) {
          return Observable.forkJoin(
            this.planService.postPersonPlan(personAccomPlan),
            this.planService.updatePersonPlan(updatePersonEllPlan),
            this.planService.updateRequest(updateRequest)
          );
        } else {
          return Observable.forkJoin(
            this.planService.postPersonPlan(personAccomPlan),
            this.planService.postPersonPlan(personEllPlan),
            this.planService.updateRequest(updateRequest)
          );
        }
      } else if (this.accommodationPlan) {
        if (this.savedAccomsPesronId) {
          return Observable.forkJoin(
            this.planService.updatePersonPlan(updatePersonAccomPlan),
            this.planService.updateRequest(updateRequest)
          );
        } else {
          return Observable.forkJoin(
            this.planService.postPersonPlan(personAccomPlan),
            this.planService.updateRequest(updateRequest)
          );
        }
      } else if (this.ellSupportDiv) {
        if (this.savedEllPesronId) {
          return Observable.forkJoin(
            this.planService.updatePersonPlan(updatePersonEllPlan),
            this.planService.updateRequest(updateRequest)
          );
        } else {
          return Observable.forkJoin(
            this.planService.postPersonPlan(personEllPlan),
            this.planService.updateRequest(updateRequest)
          );
        }
      } else {
        return Observable.empty();
      }
    }
  }
  goToReason = () => {
    this.stepper.goToPrevStep();
  }
  public planSelected(selectedPlan) {
    this.errorMsg = false;
    this.showaccommodationPlan = false;
    this.savedPlanDuration = "";
    this.planId = selectedPlan.PLAN_ID;
    this.enableSaveContinue = false;
    if (selectedPlan.PLAN_TYPE === "4MO" || selectedPlan.PLAN_TYPE === "1YR") {
      this.planTypeDiv = true;
      this.exceptionFlag = false;
      if (selectedPlan.PLAN_TYPE === "4MO") {
        this.oneyearDiv = false;
        this.planDuration = "4 Months";
        this.fourmoDiv = true;
      } else {
        this.fourmoDiv = false;
        this.planDuration = "Twelve Calendar Months";
        this.oneyearDiv = true;
      }
    } else if (selectedPlan.PLAN_TYPE === "NONE") {
      this.selectedPlanDuration = "NONE";
      this.exceptionFlag = true;

      this.planTypeDiv = false;
    } else {
      this.planTypeDiv = false;
    }
  }
  public selectedEllPlan(ellPlan) {
    this.errorMsg = false;
    this.showEllDiv = false;
    if (ellPlan === "Yes") {
      this.ellValue = "Y";
      this.ellPlanFlag = true;
    } else if (ellPlan === "No") {
      this.ellValue = "N";
      this.ellPlanFlag = true;
    }
  }
  public onSelectedPlanDuration(planDuration, prm) {
    this.errorMsg = false;
    this.showPlanTypeDiv = false;
    if (prm === "months") {
      this.planFourMonthFlag = true;
      this.planOneYearFlag = false;

      this.selectedPlanDuration =
        planDuration === "4 Months or More" ? "=>4" : "<4";
    } else {
      this.planFourMonthFlag = false;
      this.planOneYearFlag = true;

      this.selectedPlanDuration =
        planDuration === "Twelve Calendar Months or More" ? "=>1" : "<1";
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/accsupportplan/accsupportplan.component.ts